import { render, staticRenderFns } from "./StatsSummaryCard.vue?vue&type=template&id=4da6e988&"
import script from "./StatsSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./StatsSummaryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports